import { Badge } from '@/components/ui/Badge';
import { CampaignRecommendationsTab } from '@/components/CampaignRecommendationsTab';
import { KeywordRecommendationsTab } from '@/components/KeywordRecommendationsTab';
import { RuleRecommendationTables } from '@/components/recommendations/ruleTables/RuleRecommendationTables';
import { useAppDateRange } from '@/contexts/AppDateRangeContext';
import { isRangeValid } from '@/api/reportDateRanges';

export function SpRecommendationsTab({
  profileId,
  accountName: _accountName,
}: {
  profileId: string;
  accountName?: string | null;
}) {
  const { range: rangeState } = useAppDateRange();
  const range = rangeState.current;
  const rangeOk = isRangeValid(range);

  return (
    <div className="mx-auto w-full max-w-[1380px] px-6 pb-8 pt-1">
      <header className="mb-4">
        <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
          <h1 className="text-2xl font-semibold text-foreground">Recommendations</h1>
          <Badge variant="neutral" className="normal-case tracking-normal font-medium">
            Amazon
          </Badge>
          <span className="text-sm text-foreground-subtle">|</span>
          <span className="font-mono text-sm text-foreground-muted">{profileId}</span>
        </div>
      </header>

      <div className="space-y-6">
        <RuleRecommendationTables profileId={profileId} range={range} rangeOk={rangeOk} />
        <CampaignRecommendationsTab profileId={profileId} range={range} rangeOk={rangeOk} />
        <KeywordRecommendationsTab profileId={profileId} range={range} rangeOk={rangeOk} />
      </div>
    </div>
  );
}
